export const DEFAULT_PPO_FEE = 1000

export const DEFAULT_ANNUAL_COST = 99
export const DEFAULT_MONTHLY_COST = 10.99
export const DEFAULT_MONTHLY_STUDENT_COST = 4.99
export const DEFAULT_MONTHLY_SNAP_EBT_COST = 4.99

export const AVERAGE_MONTHLY_SAVINGS = 19.64
export const AVERAGE_PREFERRED_SHOPPERS = 4
